import type { ReactElement } from "react";

export const INSTAGRAM = function () {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="23"
      fill="none"
      viewBox="0 0 23 23"
      aria-hidden
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M6.083 0h10.389c3.337 0 6.082 2.745 6.082 6.083v10.335c0 3.337-2.745 6.082-6.082 6.082H6.082C2.746 22.5 0 19.755 0 16.418V6.082C0 2.745 2.745 0 6.083 0zm11.25 3.93c.7 0 1.292.592 1.292 1.292 0 .7-.593 1.292-1.293 1.292a1.276 1.276 0 01-1.291-1.292c0-.7.537-1.292 1.291-1.292zM11.25 5.114h.054c3.338 0 6.137 2.8 6.137 6.137 0 3.39-2.8 6.136-6.137 6.136h-.054c-3.337 0-6.083-2.745-6.083-6.136 0-3.338 2.746-6.137 6.083-6.137zm0 2.1h.054c2.207 0 4.037 1.83 4.037 4.037 0 2.26-1.83 4.09-4.037 4.09h-.054c-2.207 0-4.037-1.83-4.037-4.09 0-2.207 1.83-4.037 4.037-4.037zM6.137 1.938h10.28a4.204 4.204 0 014.199 4.198v10.227a4.204 4.204 0 01-4.198 4.198H6.136a4.204 4.204 0 01-4.199-4.198V6.137a4.204 4.204 0 014.199-4.199z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};

export const FB = function () {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      aria-hidden
    >
      <path
        fill="#fff"
        d="M13.876 13.27h2.343l.938-3.75h-3.281V7.647c0-.966 0-1.875 1.875-1.875h1.406V2.62c-.306-.04-1.46-.131-2.679-.131-2.545 0-4.352 1.553-4.352 4.406V9.52H7.313v3.75h2.813v7.968h3.75v-7.968z"
      ></path>
    </svg>
  );
};

export const YOUTUBE = function () {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 256 256"
      fill="#fff"
      aria-hidden
    >
      <path d="M234.33 69.52a24 24 0 00-14.49-16.4C185.56 39.88 131 40 128 40s-57.56-.12-91.84 13.12a24 24 0 00-14.49 16.4C19.08 79.5 16 97.74 16 128s3.08 48.5 5.67 58.48a24 24 0 0014.49 16.41C69 215.56 120.4 216 127.34 216h1.32c6.94 0 58.37-.44 91.18-13.11a24 24 0 0014.49-16.41c2.59-10 5.67-28.22 5.67-58.48s-3.08-48.5-5.67-58.48zm-73.74 65l-40 28A8 8 0 01108 156v-56a8 8 0 0112.59-6.55l40 28a8 8 0 010 13.1z"></path>
    </svg>
  );
};

type TSocialIcon = () => ReactElement;

export type TSocialLink = {
  Icon: TSocialIcon;
  href: string;
  label: string;
};

/**
 * Builds the footer social links for a partner in display order, omitting any
 * network the partner hasn't set. Takes the URLs rather than the whole theme so
 * it can be called from both server and client footers.
 */
export const getSocialLinks = ({
  facebookURL,
  instagramURL,
  youtubeURL,
}: {
  facebookURL?: string;
  instagramURL?: string;
  youtubeURL?: string;
}): TSocialLink[] => {
  const candidates: { Icon: TSocialIcon; href?: string; label: string }[] = [
    { Icon: INSTAGRAM, href: instagramURL, label: "Instagram" },
    { Icon: FB, href: facebookURL, label: "Facebook" },
    { Icon: YOUTUBE, href: youtubeURL, label: "YouTube" },
  ];

  return candidates.filter((link): link is TSocialLink => Boolean(link.href));
};
